export default __webpack_public_path__ + "static/media/logo_issgb.95ddd99f.png";